import { useLayoutEffect, useMemo, useState } from 'react';

import AutoComplete from 'components/field/AutoComplete';
import FormItem from 'components/form/FormItem';

import { AUTOCOMPLETE } from 'services/consts';

const OrderAutocomplete = ({ label, toolTip, isLoading, handleChange, generateOrderData, defaultOrderData }) => {
	const [orderId, setOrderId] = useState(null);

	const orderAutocompleteColumns = useMemo(() => [{ accessor: 'orderID', width: 200 }], []);

	useLayoutEffect(() => {
		if (orderId) {
			handleChange(orderId);
		} else {
			generateOrderData(defaultOrderData);
		}
	}, [orderId]);

	return (
		<FormItem label={label} toolTip={toolTip} isLoading={isLoading}>
			<AutoComplete
				className="orderId"
				autoCompleteName={AUTOCOMPLETE.ORDERS}
				columns={orderAutocompleteColumns}
				selectionLabelAccessor={['orderID']}
				value={orderId}
				setValue={(value, firstRender) => {
					if (firstRender) return;
					if (value?.ID) {
						setOrderId(value.ID);
					} else {
						setOrderId(null);
					}
				}}
				disabled={isLoading}
			/>
		</FormItem>
	);
};

export default OrderAutocomplete;
